import React from "react";
import { FaRegClock } from "react-icons/fa";
import { Row, Col, Card, Button, Image, Badge } from "react-bootstrap";
import { FaPaperPlane } from "react-icons/fa";
import ulefone from "../../assets/img/vendors/ulefone.png";
import huawei from "../../assets/img/vendors/huawei.png";
import hvezda from "../../assets/img/favicon.png";

class Home extends React.Component {
  componentDidMount() {
    this.props.setHeaderPage({
      Icon: <FaPaperPlane className="c-placeholder c-green" />,
      Title: "Novinky",
      SubTitle: "",
    });
  }

  render() {
    return (
      <>
        <Row>
          <Col className="d-flex justify-content-center mt-4 mb-4">
            <Button variant="success" size="sm" onClick={() => window.location.replace("https://old.britex.cz")}>Přejít do starého webu</Button>
          </Col>
        </Row>

        <Row className="mt-4">
          <Col>
            <Card>
              <Card.Body>
                <Row>
                  <Col className="d-flex justify-content-end align-item-center">
                    <FaRegClock className="me-2 text-muted" />
                    <small className="align-center text-muted">23.8.2022</small>
                  </Col>
                </Row>
                <Row className="mb-4">
                  <Col className="d-flex align-items-center">
                    <span class="d-flex align-items-center me-4 c-shadow-wrapper ">
                      <Image
                        src={hvezda}
                        className="c-news-logo c-news-squircle bg-overlay"
                      />
                    </span>
                    <span className="h5">
                      Nový Web
                    </span>
                  </Col>
                </Row>
                <p className="text-muted mb-4">
                  Dovolujeme si oznámit, že byl spuštěn nový web naší firmy BRITEX-CZ, s.r.o. Web je postaven přesně na míru našim požadavkům. Díky našim novým internetovým stránkám jsme nyní schopni zajistit našim zákazníkům a obchodním partnerům akuální informace o servisní zakázce, cenové nabídky a dalších užitečných věcí. Web je stále ve vývoji a některé funkce ještě nejsou dostupné.              </p>                <hr />
                <Row>
                  <Col xs={6}>
                    <Image src={hvezda} className="c-avatar" />{" "}
                    <strong className="me-4">Britex</strong>
                  </Col>
                  <Col xs={6}>
                    <Badge pill bg="secondary" className="me-2">
                      Obchodní sdělení
                    </Badge>
                    <Badge pill bg="secondary" className="me-2">
                      Servisní oddělení
                    </Badge>
                  </Col>
                </Row>
              </Card.Body>
            </Card>
          </Col>
        </Row>

        <Row className="mt-4">
          <Col>
            <Card>
              <Card.Body>
                <Row>
                  <Col className="d-flex justify-content-end align-item-center">
                    <FaRegClock className="me-2 text-muted" />
                    <small className="align-center text-muted">30.8.2021</small>
                  </Col>
                </Row>
                <Row className="mb-4">
                  <Col className="d-flex align-items-center">
                    <span class="d-flex align-items-center me-4 c-shadow-wrapper ">
                      <Image
                        src={ulefone}
                        className="c-news-logo c-news-squircle bg-overlay"
                      />
                    </span>
                    <span className="h5">
                      Nově zastřešujeme opravy pro značku UleFone
                    </span>
                  </Col>
                </Row>
                <p className="text-muted mb-4">
                  Ulefone, celým názvem Gotron Group Co., Ltd., je čínský
                  výrobce smartphonů založený v roce 2010. Sídlo firmy je v
                  Šen-čenu, konkrétně v Shenzhen's Tsinghua Hi-tech Park.
                  Ulefone vyrábí chytré telefony se systémem Android, které jsou
                  dle jejich slov cenově přijatelné.
                </p>
                <hr />
                <Row>
                  <Col xs={6}>
                    <Image src={hvezda} className="c-avatar" />{" "}
                    <strong className="me-4">Britex</strong>
                  </Col>
                  <Col xs={6}>
                    <Badge pill bg="secondary" className="me-2">
                      Obchodní sdělení
                    </Badge>
                    <Badge pill bg="secondary" className="me-2">
                      Servisní oddělení
                    </Badge>
                    <Badge pill bg="secondary" className="me-2">
                      Autorizace
                    </Badge>
                  </Col>
                </Row>
              </Card.Body>
            </Card>
          </Col>
        </Row>

        <Row className="mt-4">
          <Col>
            <Card>
              <Card.Body>
                <Row>
                  <Col className="d-flex justify-content-end align-item-center">
                    <FaRegClock className="me-2 text-muted" />
                    <small className="align-center text-muted">21.6.2021</small>
                  </Col>
                </Row>
                <Row className="mb-4">
                  <Col className="d-flex align-items-center">
                    <span class="d-flex align-items-center ms-4 me-4 c-shadow-wrapper ">
                      <Image
                        src={huawei}
                        className="c-news-logo c-news-squircle bg-overlay"
                      />
                    </span>
                    <span className="h5">
                      Ukončení spolupráce s výrobcem HUAWEI
                    </span>
                  </Col>
                </Row>
                <p className="text-muted mb-4">
                  Vážený zákazníku. Dovolujeme si Vás touto cestou informovat,
                  že ode dne 23.6.2021 nebudeme nadále přijímat k opravám
                  přístroje výrobce Huawei. Veškeré opravy zadané před tímto
                  datem budou řádně dokončeny. Po tomto datu se se svými
                  požadavky záručního a pozáručního servisu tohoto výrobce
                  obracejte na autorizované servisní středisko. Spolupráce
                  BRITEX- CZ, s.r.o. s výrobcem Huawei bude ukončena ke dni
                  30.6.2021. Děkujeme za pochopení.
                </p>
                <hr />
                <Row>
                  <Col xs={6}>
                    <Image src={hvezda} className="c-avatar" />{" "}
                    <strong className="me-4">Britex</strong>
                  </Col>
                  <Col xs={6}>
                    <Badge pill bg="secondary" className="me-2">
                      Obchodní sdělení
                    </Badge>
                    <Badge pill bg="secondary" className="me-2">
                      Servisní oddělení
                    </Badge>
                    <Badge pill bg="secondary" className="me-2">
                      Autorizace
                    </Badge>
                  </Col>
                </Row>
              </Card.Body>
            </Card>
          </Col>
        </Row>
        {1 == 0 && (
          <Row>
            <Col className="d-flex justify-content-center mt-4 mb-4">
              <Button variant="success">Načíst více</Button>
            </Col>
          </Row>
        )}
      </>
    );
  }
}

export default Home;
